import { noop } from '@direct-frontend/stdlib';
import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiFormDataRequest } from '#shared/api/requests';
import {
    type OpenApiImportCharacteristicGroupsResponseSuccess,
    OpenApiImportCharacteristicGroupsUrl,
} from '#shared/api/schema';
import { api, GroupsListTag } from './api';

const importApi = createApi({
    name: 'entities/characteristic/api/import',
    tagTypes: [],
    baseQuery: createBaseQuery(apiFormDataRequest),
    endpoints: (builder) => {
        return {
            importGroups: builder.mutation<OpenApiImportCharacteristicGroupsResponseSuccess, FormData>({
                query: (payload) => {
                    return {
                        url: OpenApiImportCharacteristicGroupsUrl,
                        method: 'POST',
                        body: payload,
                    };
                },
                async onQueryStarted(_payload, { queryFulfilled }) {
                    const queryFulfilledResult = await queryFulfilled.catch(noop);

                    if (queryFulfilledResult === undefined) {
                        return;
                    }

                    api.util.invalidateTags([GroupsListTag]);
                },
            }),
        };
    },
});

export const importCharacteristicGroups = importApi.endpoints.importGroups.mutate;
